import { useEffect, useCallback } from "react";
import { detectBarcodeFormat } from "../pages/hdi-scanner-page/hdiScannerPageUtils";
import { handleScanResult } from "../helpers/handleScanResultUtils";
import { SymbologyType } from "../types/SymbologyType";

export function useScannerInput(
  onScan: (value: string, symbologyFormat: SymbologyType) => void
) {
  // To avoid focusing on input element which pops up keyboard,
  // focus the input element only when a scan event occurs by listening for input changes.
  useEffect(() => {
    const handleScan = (e: KeyboardEvent) => {
      const inputElement = document.getElementById(
        "scanner-text-input"
      ) as HTMLInputElement | null;
      if (!inputElement) return;

      // If the input isn't already focused and the key is a character, focus it
      if (document.activeElement !== inputElement && e.key.length === 1) {
        inputElement.focus();
      }
    };

    window.addEventListener("keydown", handleScan);
    return () => {
      window.removeEventListener("keydown", handleScan);
    };
  }, []);

  return useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.trim();
      const symbologyFormat = detectBarcodeFormat(value);
      onScan(value, symbologyFormat);
    },
    [onScan]
  );
}

export function processScanResult(
  value: string,
  symbologyFormat: SymbologyType,
  taskType: string,
  navigate: (path: string) => void
) {
  const scanResult = {
    scannedBarcode: value,
    symbologyFormat,
  };
  handleScanResult(scanResult, taskType, navigate);
}
